import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Video {
  constructor(element) {
    this.element = element;
    this.video = document.querySelector(".js-video");
    this.video360 =  this.video.getAttribute("data-video-360");
    this.video540 =  this.video.getAttribute("data-video-540");
    this.video720 =  this.video.getAttribute("data-video-720");
    this.video1080 =  this.video.getAttribute("data-video-1080");
    this.videoButton = document.querySelector(".js-video-button");
    this.videoButtonIcon = document.querySelector(".js-video-button .c-button__icon");
    this.videoButtonLabel = document.querySelector(".js-video-button .c-button__label");
    this.iconPause ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M6.48 16.313H3.757c-1.395 0-2.07-.645-2.07-1.98V3.668c0-1.336.675-1.98 2.07-1.98H6.48c1.395 0 2.07.645 2.07 1.98v10.664c0 1.335-.675 1.98-2.07 1.98Zm-2.723-13.5c-.81 0-.945.202-.945.854v10.665c0 .653.128.855.946.855H6.48c.81 0 .945-.202.945-.854V3.668c0-.653-.127-.856-.945-.856H3.757ZM14.242 16.313H11.52c-1.395 0-2.07-.645-2.07-1.98V3.668c0-1.336.675-1.98 2.07-1.98h2.722c1.395 0 2.07.645 2.07 1.98v10.664c0 1.335-.675 1.98-2.07 1.98Zm-2.722-13.5c-.81 0-.945.202-.945.854v10.665c0 .653.127.855.945.855h2.722c.81 0 .945-.202.945-.854V3.668c0-.653-.127-.856-.945-.856H11.52Z"/></svg>';
    this.iconPlay ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M5.902 15.96a3.28 3.28 0 0 1-1.65-.428c-1.17-.675-1.814-2.047-1.814-3.854V6.33c0-1.815.644-3.18 1.815-3.855 1.17-.675 2.677-.548 4.252.36l4.627 2.67c1.568.907 2.438 2.152 2.438 3.502 0 1.35-.863 2.595-2.438 3.503l-4.627 2.67c-.908.518-1.793.78-2.603.78Zm0-12.795c-.405 0-.764.09-1.087.277-.81.465-1.253 1.493-1.253 2.888v5.34c0 1.395.443 2.415 1.253 2.887.81.473 1.92.338 3.127-.36l4.628-2.67c1.207-.697 1.875-1.59 1.875-2.527 0-.938-.668-1.83-1.875-2.528l-4.628-2.67c-.735-.42-1.425-.637-2.04-.637Z"/></svg>';
    this.videoContent ='<video alt="" autoplay muted loop playsinline><source src="'+ this.video360+'" media="(max-width: 640px)"><source src="'+ this.video540+'" media="(max-width: 853px)"> <source src="'+ this.video720+'" media="(max-width: 1280px)"><source src="'+ this.video1080+'" type="video/mp4"></video>'


    this.click = this.click.bind(this);
  }

  mount() {
    this.video.innerHTML= this.videoContent;


    window.addEventListener("resize", this.click)

    if(this.videoButton) {
      this.videoButton.addEventListener("click", this.click)
    }
  }

  resize() {

  }

  click() {
    this.video = document.querySelector(".js-video video");

    if (this.video.paused == true) {
      this.video.play();
      this.videoButtonLabel.innerHTML = "Pause";
      this.videoButtonIcon.innerHTML = this.iconPause;
    } else {
      this.video.pause();
      this.videoButtonLabel.innerHTML = "Play";
      this.videoButtonIcon.innerHTML = this.iconPlay;
    }
  }

  unmount() {

  }
}
